// Auto-incremented by scripts/bump-version.mjs on every deploy. Do not edit by hand.
export const APP_VERSION = '1.0.1';
